import React, { PureComponent } from 'react';
import { findDOMNode } from "react-dom";
import { scaleLinear } from 'd3'

import Slider from './Slider'

class Column extends PureComponent{

  render(){
    const { label, data, portfolios, factors, rates, volatilityAssumptions,
      onChange } = this.props;
    const yMax = window.innerWidth < 768 ? 125 : 215; // hard coded elsewhere

    return (<div className="column"
      tabIndex={0}
      onMouseDown={() => {
        const node = findDOMNode(this);
        if(document.activeElement !== node){
          node.focus();
        } else {
          window.setTimeout(() => {
            node.blur();
          }, 1);
        }
      }}>
      <div className="values">
        <div className="column-header">{label}</div>
        {Object.keys(data).map(o =>
          rates
            ? <div key={o}>
                {volatilityAssumptions &&
                  <div className="monte-carlo-sliders-label">{data[o]}</div>}
                <Slider 
                  disabled={!portfolios.original[o]}
                  factor={o}
                  label={volatilityAssumptions ? 'Expected Returns' : data[o]}
                  value={factors[o]}
                  scale={scaleLinear()
                    .domain([-1000, 1000])
                    .range([0, yMax])}
                  rateAnchor={rates[o] && rates[o].rate}
                  rate={true}
                  onChange={(factor, value) => onChange(factor, value, volatilityAssumptions ? 'expectedReturnAssumptions' : null)} />
                {volatilityAssumptions && <Slider 
                  disabled={!portfolios.original[o]}
                  key={o}
                  label={'Volatility'}
                  factor={o}
                  value={volatilityAssumptions[o]}
                  scale={scaleLinear()
                    .domain([rates[o] && rates[o].rate ? -1e4*rates[o].rate : 0, 1000])
                    .range([0, yMax])}
                  rateAnchor={rates[o] && rates[o].rate}
                  rate={true}
                  onChange={(factor, value) => onChange(factor, value, volatilityAssumptions ? 'expectedVolatilityAssumptions' : null)} />}
              </div>
            : <div key={o}>
                {volatilityAssumptions &&
                  <div className="monte-carlo-sliders-label">{data[o]}</div>}
                <Slider 
                  disabled={!portfolios.original[o]}
                  factor={o}
                  label={volatilityAssumptions ? 'Expected Returns' : data[o]}
                  value={factors[o]}
                  scale={scaleLinear()
                    .domain([-1,1])
                    .range([0, yMax])}
                  onChange={(factor, value) => onChange(factor, value, volatilityAssumptions ? 'expectedReturnAssumptions' : null)} />
                {volatilityAssumptions && <Slider 
                  disabled={!portfolios.original[o]}
                  key={o}
                  label={'Volatility'}
                  factor={o}
                  value={volatilityAssumptions[o]}
                  scale={scaleLinear()
                    .domain([0,1])
                    .range([0, yMax])}
                  onChange={(factor, value) => onChange(factor, value, volatilityAssumptions ? 'expectedVolatilityAssumptions' : null)} />}
              </div>
        )}
      </div>
      <svg width={13} height={6}><path d="M 0 0 H 13 L 6.5 6 Z" /></svg>
    </div>);
  }
}

export default Column


// WEBPACK FOOTER //
// ./src/components/Column/index.js